<script>
    import {Line} from 'vue-chartjs'

    export default {
        name: "LineChartVertical",
        extends: Line,
        components: {},
        data() {
            return {
                chartData: {
                    datasets: [
                        {
                            label: 'Data Two',
                            data: this.calculateChart([0]),
                            pointRadius: 16,
                            pointBackgroundColor: '#ffffff',
                            pointBorderColor: '#06ce9f',
                            pointBorderWidth: 20,
                            fill: false,
                        },
                        {
                            label: 'Data Two',
                            data: this.calculateChart([this.$store.state.selectedMaturity]),
                            pointRadius: 16,
                            pointBackgroundColor: '#ffffff',
                            pointBorderColor: '#004666',
                            pointBorderWidth: 20,
                            fill: false,
                        },
                        {
                            label: 'Data One',
                            data: this.calculateChart([0.5, 1, 2, 3, 4, 5, 5.5]),
                            pointRadius: 0,
                            borderColor: '#a8adb3',
                            fill: false,
                        },

                    ]
                },
                chartOptions: {
                    responsive: true,
                    maintainAspectRatio: false,
                    legend: {
                        display: false
                    },
                    scales: {
                        xAxes: [{
                            type: 'linear',
                            gridLines: false,
                            scaleLabel: {
                                display: false
                            },
                            ticks: {
                                display: false
                            }
                        }],

                        yAxes: [{
                            gridLines: false,
                            scaleLabel: {
                                display: false
                            },
                            ticks: {
                                display: false
                            }
                        }]
                    },
                    layout: {
                        padding: {
                            left: 0,
                            right: 0,
                            top: 0,
                            bottom: 0
                        }
                    },
                    tooltips: {
                        enabled: false
                    },
                    hover: {mode: null},
                },
                refresh: false
            }
        },
        mounted() {
            this.chartData.datasets[0].data = this.calculateChart([this.calculatedValue]);
            if (this.$store.state.selectedMaturity === this.calculatedValue) {
                this.chartData.datasets[0].pointRadius = 14;
                this.chartData.datasets[0].pointBorderWidth = 10;
            }
            this.renderChart(this.chartData, this.chartOptions)
        },
        methods: {
            calculateChart(xPoints) {
                let points = [];
                xPoints.forEach(function (val) {
                    points.push({
                        x: 0.5,
                        y: val,
                    })
                });
                return points
            },
            calcY(xVal) {
                return 2 ** xVal
            },
        },
        computed: {
            calculatedValue() {
                return (this.$store.getters.getOverallReadiness / this.$store.getters.getMaxWeights.total * 4) + 1;
            }
        },
    }
</script>
